import React from "react";

const Footer = () => {
  return (
    <footer
      style={{ marginTop: "20px", padding: "20px", backgroundColor: "#333333" }}
    >
      <p style={{ color: "white", textAlign: "center" }}>
        Made with 💖 by <strong>AbdElRahman Mostafa ElSayed </strong>
      </p>
    </footer>
  );
};

export default Footer;
